import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    CreateFormQuestionOptionBody,
    UpdateFormQuestionOptionBody,
    MoveFormQuestionOptionBody,
    FormQuestionOptionResponse,
    createFormQuestionOption,
    updateFormQuestionOption,
    moveFormQuestionOption,
    deleteFormQuestionOption,
    duplicateFormQuestionOption,
} from '../../services/apiSLTP/qhse/forms/formQuestionOptions';

// --- CREATE ---
type UseCreateFormQuestionOptionMutationOptions = MutationOptions<FormQuestionOptionResponse, Error, CreateFormQuestionOptionBody>;
export const useCreateFormQuestionOptionMutation = (options?: UseCreateFormQuestionOptionMutationOptions) => {
    const mutationFn: MutationFunction<FormQuestionOptionResponse, CreateFormQuestionOptionBody> = async (data) => {
        return createFormQuestionOption(data);
    };
    return useMutation(mutationFn, options);
};

// --- UPDATE ---
type UseUpdateFormQuestionOptionMutationOptions = MutationOptions<
    FormQuestionOptionResponse,
    Error,
    { optionId: string; data: UpdateFormQuestionOptionBody }
>;
export const useUpdateFormQuestionOptionMutation = (options?: UseUpdateFormQuestionOptionMutationOptions) => {
    const mutationFn: MutationFunction<FormQuestionOptionResponse, { optionId: string; data: UpdateFormQuestionOptionBody }> = async ({
        optionId,
        data,
    }) => {
        return updateFormQuestionOption(optionId, data);
    };
    return useMutation(mutationFn, options);
};

// --- MOVE ---
type UseMoveFormQuestionOptionMutationOptions = MutationOptions<
    FormQuestionOptionResponse,
    Error,
    { optionId: string; data: MoveFormQuestionOptionBody }
>;
export const useMoveFormQuestionOptionMutation = (options?: UseMoveFormQuestionOptionMutationOptions) => {
    const mutationFn: MutationFunction<FormQuestionOptionResponse, { optionId: string; data: MoveFormQuestionOptionBody }> = async ({
        optionId,
        data,
    }) => {
        return moveFormQuestionOption(optionId, data);
    };
    return useMutation(mutationFn, options);
};

// --- DELETE ---
type UseDeleteFormQuestionOptionMutationOptions = MutationOptions<{ message: string }, Error, { optionId: string }>;
export const useDeleteFormQuestionOptionMutation = (options?: UseDeleteFormQuestionOptionMutationOptions) => {
    const mutationFn: MutationFunction<{ message: string }, { optionId: string }> = async ({ optionId }) => {
        return deleteFormQuestionOption(optionId);
    };
    return useMutation(mutationFn, options);
};

// --- DUPLICATE ---
type UseDuplicateFormQuestionOptionMutationOptions = MutationOptions<FormQuestionOptionResponse, Error, { optionId: string }>;
export const useDuplicateFormQuestionOptionMutation = (options?: UseDuplicateFormQuestionOptionMutationOptions) => {
    const mutationFn: MutationFunction<FormQuestionOptionResponse, { optionId: string }> = async ({ optionId }) => {
        return duplicateFormQuestionOption(optionId);
    };
    return useMutation(mutationFn, options);
};
